import { useEffect, useState } from 'react';

import { isLoaded } from 'src/app/shared/utils/async';

import type { RootShareRecommendations } from '../useFetchShareRecommendations';
import { useFetchShareRecommendations } from '../useFetchShareRecommendations';

export type Recommendation = NonNullable<
	NonNullable<RootShareRecommendations['facebook'] | RootShareRecommendations['reddit']>[0]
>;
type UseShareRecommendationsReturn = ModelHookResult<{
	shareRecommendations: RootShareRecommendations;
	shouldDisplayShareRecommendations: boolean;
	shareRecommendationsLoading: boolean;
}>;

export const EMPTY_SHARE_RECOMMENDATIONS: RootShareRecommendations = {
	facebook: [],
	reddit: [],
};

export function useShareRecommendations(slug: string): UseShareRecommendationsReturn {
	const [shareRecommendationsLoading, setShareRecommendationsLoading] = useState(true);
	const [shareRecommendations, setShareRecommendations] =
		useState<RootShareRecommendations>(EMPTY_SHARE_RECOMMENDATIONS);
	const [hasAnyShareRecommendations, setHasAnyShareRecommendations] = useState(false);
	const shareRecommendationsResult = useFetchShareRecommendations(slug);

	useEffect(() => {
		if (isLoaded(shareRecommendationsResult)) {
			setShareRecommendations(shareRecommendationsResult.data);
			setHasAnyShareRecommendations(!!shareRecommendations.reddit.length || !!shareRecommendations.facebook.length);
			setShareRecommendationsLoading(false);
		}
	}, [shareRecommendationsResult, shareRecommendationsLoading, shareRecommendations]);

	return {
		data: {
			shareRecommendations,
			shouldDisplayShareRecommendations: hasAnyShareRecommendations,
			shareRecommendationsLoading,
		},
	};
}
